import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IModalState {
    modalType: string | null
    data: any
}

const initialState: IModalState = {
    modalType: null,
    data: null,
}

const modalSlice = createSlice({
    name: 'modalSlice',
    initialState,
    reducers: {
        showModal: (state, action: PayloadAction<any>) => {
            state.modalType = action.payload.modalType
            state.data = action.payload.data
        },
        hideModal: (state) => {
            state.modalType = null
            state.data = null
        },
    },
})

export const { actions: modalActions } = modalSlice
export const { reducer: modalReducer } = modalSlice
